/** Display only: stored and computed precision is preserved. */
export function currency(value?: number | string | null): string {
  if (value == null || value === '') return 'Not recorded';
  const number = Number(value);
  return Number.isFinite(number)
    ? number.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : 'Unavailable';
}
